import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import _, { map } from 'lodash';
import { inject, injectable } from 'inversify';
import { getBeisenUser } from '@/utils/beisen';
let HistoryListService = class HistoryListService {
    constructor(historyApi) {
        this.historyApi = historyApi;
        /* 获取接口数据 */
        this.getHistoryInfo = this.historyApi.getHistoryList;
    }
    /* 获取公司历史信息 */
    getHistoryInfoManager(companyHistory) {
        const historyList = map(companyHistory, item => {
            return {
                id: item.id,
                title: `${item.log_audit_entity_action} ${item.log_audit_entity_name}`,
                createTime: item.created_at_value,
                createById: item.created_by_user_id,
                createBy: getBeisenUser({
                    defaultName: item.updated_by_user_name,
                    departmentName: item.updated_by_department_name,
                    employeeName: item.updated_by_employee_name,
                }),
                // context: this.filterData(item.log_audit_content),
                context: item.log_audit_content,
                updated_by_user_name: item.updated_by_user_name,
                // 可改：是否应该和 createById 一样
                updated_by: item.updated_by,
            };
        });
        return historyList;
    }
    filterData(list) {
        // 过滤掉包含ID的字段
        return _.filter(list, item => {
            return !_.includes(item.field_name, 'ID') && !_.includes(item.field_name, 'Id');
        });
    }
};
HistoryListService = __decorate([
    injectable(),
    __param(0, inject(Symbols.HistoryApi)),
    __metadata("design:paramtypes", [Object])
], HistoryListService);
export { HistoryListService };
